import { getToken } from '@/utils/auth';
import { Message } from 'element-ui'
let download =

  function (options) {
    let num = 1
    //创建a标签利用download属性下载文件重命名 利用文件流
      let a = document.createElement('a')
      a.download = download(options.url,options.fileName)
      // a.setAttribute('href','')
      a.click()
      //修改文件名
      function getBlob(url) {
        return new Promise(resolve => {
          const xhr = new XMLHttpRequest();
          xhr.open('GET', url, true);
          // xhr.setRequestHeader('Content-Type', 'application/json')
          xhr.setRequestHeader('Authorization', "Bearer " + getToken())
          xhr.responseType = 'blob';
          xhr.onload = () => {
            if (xhr.status === 200) {
              resolve(xhr.response);
              Message({
                message: '下载成功',
                type: 'success',
                duration: 3000
              });
            }else{
              // reject('导出失败')
              num++
              if(num < 5){
                a.download = download(options.url, options.fileName)
                a.click()
              } else {
                Message({
                  message: '文件已丢失',
                  type: 'error',
                  duration: 3000
                });
              }
            }
          };
          xhr.send();
        });
      }
      function saveAs(blob, filename) {
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, filename);
        } else {
          const link = document.createElement('a');
          const body = document.querySelector('body');

          link.href = window.URL.createObjectURL(blob);
          link.download = filename;

              // fix Firefox
          link.style.display = 'none';
          body.appendChild(link);
              
          link.click();
          body.removeChild(link);

          window.URL.revokeObjectURL(link.href);
        }
      }
      function download(url, filename,callback) {
        getBlob(url).then(blob => {
          saveAs(blob, filename);
        })
      }  
    
  }; /* end download() */


export default download



// WEBPACK FOOTER //
// ./src/utils/downloadFile.js